import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'jobMonitor';

const jobMonitorService = {
  getProductionOperations: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations`,
      data,
    });
  },

  getProductionOperationsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/view`,
      data,
    });
  },

  getProductionOperationsSortedByDeadline: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/jobmonitorTaskAssigment`,
      data,
    });
  },
};

export default jobMonitorService;
